import { memo, useState } from "react";
import noImage from "../../../assets/no_image.jpg";
import { imageUrl } from "../utils/scoreFormatter";

/** Product photo from the image host; lazy-loaded, falls back to the placeholder. */
function ProductImage({ path, alt, className = "", eager = false, style }) {
  const [failed, setFailed] = useState(false);
  return (
    <img
      className={`ep-img ${className}`}
      src={failed ? noImage : imageUrl(path)}
      alt={alt}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      style={style}
      onError={() => setFailed(true)}
    />
  );
}

export default memo(ProductImage);
